export default __webpack_public_path__ + "static/media/pattern-herringBone-40-2.37040c97.jpg";